import TimerManager from "../../services/TimerManager";
import {
    ErrorCodes,
    TypeOfFinalTransaction,
    GetAppointmentsResponse,
    ConfirmedArrivedResponse
} from "../../dtos/KioskDtos.dtos";
import Client from "../../services/Client";
import { put, takeLatest } from "redux-saga/effects";
import {
    stageAppointments,
    showConfirmationSection,
    confirmAppointment,
} from "../../store/Appointment/actions";
import { push } from "../../store/Routing/actions";
import { Routes } from "../../constants/routes";
import { toggleNetworkLoadingSpinnerVisibility } from "../../store/LoadingSpinner/actions";
import { errorHandlerSaga, expectedErrorHandlerSaga } from "../errorSaga";
import { redirectToSurvey } from "../surveyRedirectSaga";
import {
    GET_PATIENT_APPOINTMENTS,
    POST_CONFIRM_APPOINTMENT
} from "./constant";
import {
    GetPatientAppointmentsFromServerAction,
    PostConfirmAppointmentToServerAction
} from "./types";
import { debugDispatchSaga } from "../debugDispatchSaga";


export function* getPatientAppointmentsFromServerSaga(action: GetPatientAppointmentsFromServerAction) {
    yield TimerManager.stopInactivityListener();
    yield put(toggleNetworkLoadingSpinnerVisibility(true));
    try {
        yield debugDispatchSaga("Search for Patient Appointments", false);
        const response: GetAppointmentsResponse = yield Client.getAppointments(action.payload.patientId);
        if (response.appointmentExists) {
            yield debugDispatchSaga("Patient appointments found", false, response.categorizedAppointmentData);
            yield put(stageAppointments(response.categorizedAppointmentData));
            yield put(push(Routes.appointmentConfirmation));
            yield put(showConfirmationSection(true));
        } else {
            yield expectedErrorHandlerSaga(ErrorCodes.NoAppointmentsFound);
        }
    } catch (e) {
        yield errorHandlerSaga(e);
    }
    yield put(toggleNetworkLoadingSpinnerVisibility(false));
    yield TimerManager.resetInactivityListener();
}

export function* postConfirmAppointmentToServerSaga(action: PostConfirmAppointmentToServerAction) {
    yield TimerManager.stopInactivityListener();
    try {
        yield put(toggleNetworkLoadingSpinnerVisibility(true));
        yield debugDispatchSaga("Sending appointment status change to 'In Waiting Room'", false);
        const response: ConfirmedArrivedResponse = yield Client.postArrivalStatus(action.payload.appointmentId);
        if (response.isSuccessful) {
            yield debugDispatchSaga("Patient appointment confirmation", false, "Successful");
            yield put(redirectToSurvey(confirmAppointment(true), TypeOfFinalTransaction.ExistingAppointmentConfirmed));
        } else {
            yield expectedErrorHandlerSaga(ErrorCodes.UnableToUpdateAppointmentStatus);
        }
    }
    catch (e) {
        yield errorHandlerSaga(e);
    }
    yield put(toggleNetworkLoadingSpinnerVisibility(false));
    yield TimerManager.resetInactivityListener();
}

export function* watchForAllAppointmentSagas() {
    yield takeLatest(GET_PATIENT_APPOINTMENTS, getPatientAppointmentsFromServerSaga);
    yield takeLatest(POST_CONFIRM_APPOINTMENT, postConfirmAppointmentToServerSaga);
}


// WEBPACK FOOTER //
// ./src/sagas/Appointments/sagas.ts